import queryString from 'query-string'
import { usingGet, usingPost, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { ListSimulatorTrainingScheduleSessionsModel } from 'modules/simulatorTrainings/common/types'
import { ListSimulatorTrainingMaintenanceModel } from 'modules/simulatorTrainings/common/types/instructor'

export const getSimulatorTraining = (trainingId: Guid) =>
  usingGet(`SimulatorTrainings/GetSimulatorTraining?trainingId=${trainingId}`)

export const getSimulatorTrainingSchedule = (scheduleId: Guid) =>
  usingGet(`SimulatorTrainings/GetSimulatorTrainingSchedule?scheduleId=${scheduleId}`)

export const getListSimulatorTrainingScheduleSessions = (
  params: ListSimulatorTrainingScheduleSessionsModel
) => {
  const { scheduleId, trainingId, ...rest } = params
  const queryParams = queryString.stringify(rest, { skipNull: true })
  const scheduleIdParam = scheduleId ? `/${scheduleId}` : ''
  return usingGet(
    `SimulatorTrainings/instructorLed/${trainingId}/sessions${scheduleIdParam}?${queryParams}`,
    {
      useProxy: true,
    }
  )
}

export const getSimulatorTrainingSessionLink = (sessionId: Guid) =>
  usingGet(`SimulatorTrainings/GetSimulatorTrainingSessionLink?sessionId=${sessionId}`)

export const getSpecialUsers = () => usingGet('SimulatorTrainings/ListInstructors')

export const stopSimulatorTrainingSession = (sessionId: Guid) =>
  usingPost(`SimulatorTrainings/StopSimulatorTrainingSession`, { sessionId })

export const getListSimulatorTrainingMaintenancePeriods = (
  params: ListSimulatorTrainingMaintenanceModel
) => {
  const queryParams = queryString.stringify(params, { skipNull: true })
  return usingGet(`SimulatorTrainings/ListSimulatorTrainingMaintenancePeriods?${queryParams}`)
}

export const getListInstructorLedEnrollments = (scheduleId: Guid) => {
  return usingGet(`SimulatorTrainings/instructorLed/schedules/${scheduleId}/enrollments`, {
    useProxy: true,
  })
}

export const createProductSheetUrl = (assetId: string) => {
  return createProxyUrl(`simulatorTrainings/assets/${assetId}/product-sheet`)
}

export const createProductSheetBannerImageUrl = (assetId: string) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`simulatorTrainings/assets/${assetId}/banner?token=${sessionToken}`)
}

export const createProductSheetCardImageUrl = (assetId: string) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`simulatorTrainings/assets/${assetId}/card?token=${sessionToken}`)
}
